const actions = {

  //signin
  SIGNIN_BEGIN: 'SIGNIN_BEGIN',
  INITIAL_STEP: 'INITIAL_STEP',
  SIGNIN_SUCCESS: 'SIGNIN_SUCCESS',
  SIGNIN_ERR: 'SIGNIN_ERR',
  SET_SIGNIN_OTP_STEP:'SET_SIGNIN_OTP_STEP',
  MANUAL_REJECT_STATUS:'MANUAL_REJECT_STATUS',
  SIGNING_REF_VALIDATION_FAILED: 'SIGNING_REF_VALIDATION_FAILED',

  PREVIOUS:'PREVIOUS',
  NEXT_STEP: 'NEXT_STEP',
  SET_KYC_STEP:'SET_KYC_STEP',
  SET_PW_STEP:'SET_PW_STEP',
  SET_KYC_DIALOG:'SET_KYC_DIALOG',
  KYC_PRE_FAIL: 'KYC_PRE_FAIL',
  CDD_FAIL_STATUS:'CDD_FAIL_STATUS',
  KYC_POST_FAIL: 'KYC_POST_FAIL',
  SIGNOUT_BEGIN:'SIGNOUT_BEGIN',
  SIGNOUT_SUCCESS: 'SIGNOUT_SUCCESS',

  FORGOT_BEGIN: 'FORGOT_BEGIN',
  FORGOT_SUCCESS: 'FORGOT_SUCCESS',
  FORGOT_ERR: 'FORGOT_ERR',
  // from aspirasi
  IS_LOADING : 'IS_LOADING',
  SET_DATA : 'SET_DATA',
  SET_DATAFORM : 'SET_DATAFORM',
  RESET_DATA : 'RESET_DATA',
  SET_STEP : 'SET_STEP',
  SET_DIALOG : 'SET_DIALOG',
  RESET_DIALOG : 'RESET_DIALOG',
  SUCCESS_DIALOG : 'SUCCESS_DIALOG',
  SIGNUP_ERR: 'SIGNUP_ERR',
  UNLOADING: 'UNLOADING',
  SET_KONGSI_DIALOG : 'SET_KONGSI_DIALOG',
  SET_INLINE : 'SET_INLINE',
  SET_TITLE : 'SET_TITLE',
  SET_NAME_NRIC_UPDATE_STEP : 'SET_NAME_NRIC_UPDATE_STEP',

  signinBegin: () => {
    return {
      type: actions.SIGNIN_BEGIN,
    };
  },

  previous:() =>{
    return {
      type: actions.PREVIOUS,
    };
  },
  init:() =>{
    return {
      type: actions.INITIAL_STEP,
    };
  },
  signinSuccess: data => {
    return {
      type: actions.SIGNIN_SUCCESS,
      data,
    };
  },

  signinErr: err => {
    return {
      type: actions.SIGNIN_ERR,
      err,
    };
  },

  signoutBegin: () => {
    return {
      type: actions.SIGNOUT_BEGIN,
    };
  },
  signoutSuccess: data => {
    return {
      type: actions.SIGNOUT_SUCCESS,
      data,
    };
  },

  unloading: data => {
    return {
      type: actions.UNLOADING,
      data,
    };
  },

  signupErr: err => {
    return {
      type: actions.SIGNUP_ERR,
      err,
    };
  },

  nextStep: (data) => {
    return {
      type: actions.NEXT_STEP,
      data
    };
  },

  kycPreFail: (data) => {
    return {
      type: actions.KYC_PRE_FAIL,
      data
    };
  },
  setKycStep: (data) => {
    return {
      type: actions.SET_KYC_STEP,
      data
    };
  },
  kycNameAndNricUpdateStatus: (data) => {
    return {
      type: actions.SET_NAME_NRIC_UPDATE_STEP,
      data
    };
  },
  setPWStep: (data) => {
    return {
      type: actions.SET_PW_STEP,
      data
    };
  },

  setOTPStep: (data) => {
    return {
      type: actions.SET_SIGNIN_OTP_STEP,
      data
    };
  },

  setManualRejectStep: (data) => {
    return {
      type: actions.MANUAL_REJECT_STATUS,
      data
    };
  },

  kycPostFail: (data) => {
    return {
      type: actions.KYC_POST_FAIL,
      data
    };
  },
  setDataForm: data => {
    return {
      type: actions.SET_DATAFORM,
      data,
    };
  },

  forgotErr: err => {
    return {
      type: actions.SIGNOUT_ERR,
      err,
    };
  },

  forgotBegin: () => {
    return {
      type: actions.FORGOT_BEGIN,
    };
  },

  forgotSuccess: data => {
    return {
      type: actions.FORGOT_SUCCESS,
      data,
    };
  },

  forgotErr: err => {
    return {
      type: actions.FORGOT_ERR,
      err,
    };
  },
  loading: data => {
    return {
      type: actions.IS_LOADING,
      data,
    };
  },
  setDialog: data => {
    return {
      type: actions.SET_DIALOG,
      data,
    };
  },
  setTitle: data => {
    return {
      type: actions.SET_TITLE,
      data,
    };
  },
  setKycDialog: data => {
    return {
      type: actions.SET_KYC_DIALOG,
      data,
    };
  },
  cddFailStatus: data => {
    return {
      type: actions.CDD_FAIL_STATUS,
      data,
    };
  },
  successDialog: data => {
    return {
      type: actions.SUCCESS_DIALOG,
      data,
    };
  },
  resetDialog: data => {
    return {
      type: actions.SET_DIALOG,
      data,
    };
  },
  setInline: data => {
    return {
      type: actions.SET_INLINE,
      data,
    }
  },
  signinRefValidationFailure: data => {
    return {
      type: actions.SIGNING_REF_VALIDATION_FAILED,
      data,
    };
  },
};

export default actions;
